module.exports = __webpack_public_path__ + "img/duixiu02.eff90d1c.png";